import { type MouseEvent, useCallback } from 'react'

interface UseListPageProps {
  selectedId: string | undefined
  setSelectedId: (id: string | undefined) => void
  params: { ordering: string; page: number }
  setParams: (
    updater: (prev: { ordering: string; page: number }) => { ordering: string; page: number }
  ) => void
}
export default function useListPage({
  selectedId,
  setSelectedId,
  params,
  setParams
}: UseListPageProps) {
  const isDrawerOpen = Boolean(selectedId)

  const handleRowClick = useCallback(
    (id: string) => {
      setSelectedId(id)
    },
    [setSelectedId]
  )

  const handleDrawerClose = useCallback(() => {
    setSelectedId(undefined)
  }, [setSelectedId])

  const handleChangePage = useCallback(
    (_event: unknown, newPage: number) => {
      setParams(prevState => ({ ...prevState, page: newPage + 1 }))
    },
    [setParams]
  )

  const handleRequestSort = useCallback(
    (_event: MouseEvent<unknown>, property: string) => {
      const isSameColumn = params.ordering.replace('-', '') === property
      const isAsc = isSameColumn && !params.ordering.includes('-')
      setParams(prevState => ({ ...prevState, ordering: `${isAsc ? '' : '-'}${property}` }))
    },
    [params.ordering, setParams]
  )

  return {
    isDrawerOpen,
    handleRowClick,
    handleDrawerClose,
    handleChangePage,
    handleRequestSort
  }
}
